import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }

import Loader from "./Loader.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TileCard',
  props: {
  loaded: { type: Boolean, required: false, default: true },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "header")
    ]),
    _createElementVNode("div", null, [
      (props.loaded)
        ? _renderSlot(_ctx.$slots, "body", { key: 0 })
        : (_openBlock(), _createBlock(Loader, { key: 1 }))
    ]),
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "footer")
    ])
  ]))
}
}

})